import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class KeyboardEventService {

    private customEventSource = new Subject<string>();

    customEvent$ = this.customEventSource.asObservable();

    emitCustomEvent(eventId: string): void {
        this.customEventSource.next(eventId);
    }
}
